<script lang="ts" setup>
import Co2QuizMenu from '@/components/co2quiz/Co2QuizMenu.vue';
import Co2QuizQuestionList from '@/components/co2quiz/Co2QuizQuestionList.vue';
import Co2Values from '@/components/co2quiz/Co2Values.vue';
import Co2Averages from '@/components/co2quiz/Co2Averages.vue';
import { useRoute } from 'vue-router';

const route = useRoute();
</script>

<template>
  <Co2QuizMenu />
  <Co2QuizQuestionList v-if="route.path === '/co2quiz'" />
  <Co2Values v-if="route.path === '/co2quiz/values'" />
  <Co2Averages v-if="route.path === '/co2quiz/averages'" />
</template>
